import { select } from '@js/util/select'

select('.wpforms-field', el => {
  let input = el.querySelector('textarea, input')
  if (!input) return

  let toggle = () => {
    el.classList.toggle('wpforms-field-filled', input.value.length > 0)
  }

  toggle()
  input.addEventListener('blur', toggle)

  return () => {
    input?.removeEventListener('blur', toggle)
  }
})
